module.exports = __webpack_public_path__ + "static/media/eye.fb714f5a.svg";